import React, { useMemo } from "react"
import { CallBadge } from "../CallChrome/CallBadge"
import { Agent, AgentLanguages, CountryFlags } from "../../types/Agent"

interface CallLanguageProps {
  agent: Agent
}

const getLanguageName = (languageCode: string) => {
  try {
    const displayNames = new Intl.DisplayNames(["en"], { type: "language" })
    return displayNames.of(languageCode) || languageCode.toUpperCase()
  } catch {
    return languageCode.toUpperCase()
  }
}

export default function CallLanguage({ agent }: CallLanguageProps) {
  const agentLanguage = agent?.language || AgentLanguages.English
  const languageName = useMemo(
    () => getLanguageName(agentLanguage),
    [agentLanguage],
  )

  if (!agent) return null

  const FlagComponent =
    CountryFlags[agentLanguage] || CountryFlags[AgentLanguages.English]

  return (
    <CallBadge>
      <FlagComponent width={16} height={16} title={languageName} />
      {languageName}
    </CallBadge>
  )
}
